import type { RenewalStatus } from '@policyvision/contracts';

export type { RenewalStatus };

export const RenewalStatusList: RenewalStatus[] = [
  'INITIATED',
  'IN_PROGRESS',
  'STANDBY',
  'STANDBY_INSURER',
  'DONE',
];
